/**
 *  Created by piotr@revisual.io on 15/08/2025
 */

const formatPrice = (price, discount, currency) => {
  const priceFormatter = Intl.NumberFormat(window.navigator.locale || "en-US", {
    style: "currency",
    currency,
    currencyDisplay: "narrowSymbol",
    minimumFractionDigits: 0,
  });

  // if (!price) {
  //   return "Free";
  // }

  const amount = price / 100; // Convert cents to dollars
  const discountedAmount =
    discount && discount.amount_off
      ? amount - discount.amount_off / 100
      : discount && discount.percent_off
      ? amount - (amount * discount.percent_off) / 100
      : amount;
  return priceFormatter.format(discountedAmount);
};

const formatDiscountPrice = (discount, currency) => {
  if (!discount) return null;

  const priceFormatter = Intl.NumberFormat(window.navigator.locale || "en-US", {
    style: "currency",
    currency,
    currencyDisplay: "symbol",
    minimumFractionDigits: 0,
  });

  if (discount.amount_off) {
    return `-${priceFormatter.format(discount.amount_off)}`;
  } else if (discount.percent_off) {
    return `${discount.percent_off}% off`;
  }
  return null;
};

/**
 *
 * @param {Object} price
 * @param {Object} discount
 * @returns {JSX.Element}
 * @constructor
 */
export const PlanPrice = ({ price, discount }) => {
  const discountInfo = discount ? (
    <div className={"text-muted"}>
      Discount applied:{" "}
      <span className="text-success">
        {formatDiscountPrice(discount, price.currency)}
      </span>
      . Regular price:{" "}
      <span className="text-secondary">
        {formatPrice(price.unit_amount, null, price.currency)}
      </span>
    </div>
  ) : null;

  return (
    <div>
      <h2>
        {formatPrice(price.unit_amount, discount, price.currency)}
        <span className={"subscription-plan-column-price-interval"}>
          {!price.unit_amount ? "forever" : `per ${price.recurring.interval}`}
        </span>
      </h2>
      {discountInfo}
    </div>
  );
};

export default PlanPrice;
